<div class="rask-footer-left">
    <a class="rask-footer-brand" [routerLink]="['/']" href="/core/"><span>RASK</span></a>
    <div class="me-3">
        <ng-content select="[footerLeft]"></ng-content>
    </div>
</div>
<div class="rask-footer-right">
    @if(evehubStatusFeatureActive$ | async){
    <rask-eventhub-status></rask-eventhub-status>
    }
    <div class="me-3">
        @if (currentWorkFlat$ | async) {
        <div class="statusbar">
            <rask-busy-spinner size="1"></rask-busy-spinner>
            Pågående bakgrundsjobb: <span>{{currentWorkFlat$ | async}}</span>
        </div>
        }
        <ng-content select="[footerContent]"></ng-content>
    </div>
    @if (showPending()) {
    <div class="me-3 active-activities">
        <rask-icon [icon]="getStatusIcon('Pågående')"></rask-icon>
        <rask-span>{{getPendingText()}}</rask-span>
        <div class="expander-icon">
            <rask-icon icon="far fa-arrows-from-line" [clickToOpen]="true">
                <rask-footer-activity-popover [aktiviteter]="activeAktiviteter"></rask-footer-activity-popover>
            </rask-icon>
        </div>
    </div>
    }
    @if (showError()) {
    <div class="me-3 error-activities">
        <rask-icon [icon]="getStatusIcon('Fel')"></rask-icon>
        <rask-span>{{getErrorText()}}</rask-span>
        <div class="expander-icon">
            <rask-icon icon="far fa-arrows-from-line" [clickToOpen]="true">
                <rask-footer-activity-popover [aktiviteter]="errorAktiviteter"></rask-footer-activity-popover>
            </rask-icon>
        </div>
    </div>
    }
    @if (showOk()) {
    <div class="me-3 ok-activities">
        <rask-icon class="ok-icon" [icon]="getStatusIcon('Ok')"></rask-icon>
        <rask-span>{{getOkText()}}</rask-span>
        <div class="expander-icon">
            <rask-icon icon="far fa-arrows-from-line" [clickToOpen]="true">
                <rask-footer-activity-popover [aktiviteter]="completedAktiviteter"></rask-footer-activity-popover>
            </rask-icon>
        </div>
    </div>
    }
    @if (showOk()) {
    <div class="dismiss-activities">
        <rask-icon icon="fal fa-times" (click)="dismissOkActivities()" [clickToOpen]="true"></rask-icon>
    </div>
    }
</div>